import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Questions = (props) => {
  const modules = {
    toolbar: false,
  };

  return (
    <div className="form-write">
      <ReactQuill
        className="textarea-question"
        value={props.contentValue || ""}
        onChange={props.changeContent}
        modules={modules}
      />
    </div>
  );
};
export default Questions;
